<template>
  <aside id="slider" class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul data-widget="tree" class="sidebar-menu">
        <va-slide-item
          v-for="(item,index) in slideMenuItems"
          :data="item"
          :key="index"
          :type="item.type"
          :isHeader="item.isHeader"
          :icon="item.icon"
          :name="item.name"
          :badge="item.badge"
          :items="item.items"
          :router="item.router"
          :link="item.link"
        >
        </va-slide-item>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import VASlideItem from './VASlideItem'
import { mapGetters } from 'vuex'

export default {
  name: 'va-slider',
  computed: {
    ...mapGetters([
      'slideMenuItems'
    ])
  },
  created () {

  },
  components: {
    'va-slide-item': VASlideItem
  }
}
</script>

<style>

  .sidebar-mini.sidebar-collapse .main-sidebar{
    background-color: #031A3C !important;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
    z-index: 850;
    position: fixed;
  }

  .monitor-icon::before{
    content: url("/static/img/icons/chart-line-solid.png");
    padding-left: 6px;
  }

  .cargar-icon::before{
    content: url("/static/img/icons/cloud-upload-alt-solid.png");
    padding-left: 6px;
  }


/*   .citas-r-icon::before{
    content: url("/static/img/icons/ic_dinet_logo.png");
  }

  .citas-d-icon{
    content: url("/static/img/icons/exclamation-circle-solid.png");
  }

  .invetario-s-icon{
    content: url("/static/img/icons/ic_dinet_logo.png");
  } */
  
  .seguimiento-icon::before{
    content: url("/static/img/icons/search-solid.png");
    padding-left: 6px;
  }

  .reglas-icon::before{
    content: url("/static/img/icons/exclamation-circle-solid.png");
    padding-left: 6px;
  }
  
  .productos-icon::before{
    content: url("/static/img/icons/P_icon-01.png");
    padding-left: 6px;
  }

  .avance-icon::before{
    content: url("/static/img/icons/check-square-solid.png");
    padding-left: 6px;
    }
  
  .inventario-e-icon::before{
    content: url("/static/img/icons/cube-solid.png");
    padding-left: 6px;
  }

  .servicio-icon::before{
    content: url("/static/img/icons/map-marker-alt-solid.png");
    padding-left: 7px;
  }
 

</style>



// WEBPACK FOOTER //
// Slider.vue?bf66c1fe